import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@rocketlane/ui';
import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex: 1 0 100%;
  align-items: center;
  margin-bottom: var(--spacing-05);
`;
export const FilterCriteriaWrapper = styled.div`
  max-height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
`;
export const FilterBoxWrapper = styled.div`
  min-width: 480px;
  display: flex;
  flex-direction: column;

  .ant-form-item-control-input {
    height: 40px;
  }
`;
export const AddFilterButton = styled(Button).attrs({
  size: 'small',
  variant: 'link',
  leftIcon: <FontAwesomeIcon icon={faPlus} size={12} />,
})`
  align-self: flex-start;
  margin-left: calc(-1 * var(--spacing-03));
  color: var(--gray-100);
  font-weight: var(--font-weight-bold);
  padding-left: var(--spacing-04);
`;
